import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function AboutBox(props) {
    return (
        <div className={props.aboutBox}>
            <div className="about-year-icon-content">
                <div className="icon-info">
                    <div className="about-box-icon">
                        <FontAwesomeIcon icon={props.aboutIcon} />
                    </div>
                    <div className="desc-icon">
                        <h6>{props.heading}</h6>
                        <p>{props.text}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
